import { render } from "./generation.vue?vue&type=template&id=3c2ac409"
import script from "./generation.vue?vue&type=script&lang=js"
export * from "./generation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__